import axios from "../../axios/axios-api";

export const internaPaciente = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso

    let dados = {
        nomePacienteDesconhecido: payload.nomePacienteDesconhecido,
        nomeSocial: payload.nomeSocial,
        cns: payload.cns,
        codigoEnfermaria: payload.codigoEnfermaria,
        codigoLeito: payload.codigoLeito,
        dataHoraInternacao: payload.dataHoraInternacao,
        numeroProntuario: payload.numeroProntuario,
        classificacaoRisco: payload.classificacaoRisco,
        procedencia: payload.procedencia
    }

    let header = { headers: { Authorization: "Bearer " + token } }


    return axios
        .post("/api/censo/internar", dados, header)
        .then(resp => {
            commit("sessao/setLoading", false, { root: true })

            if (resp.data.status == false) commit("sessao/setError", { status: false, msg: resp.data.msg }, { root: true })
            if (resp.data.status == true) commit("sessao/setError", { status: true, msg: resp.data.msg }, { root: true })

        })
        .catch(error => {
            commit("sessao/setLoading", false, { root: true });
        });

};